module.exports = __webpack_public_path__ + "img/accessory_shoe_02.8c4d78e9.svg";